var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.05 19.475L4.19999 12.6C4.09999 12.5 4.02915 12.4042 3.98749 12.3125C3.94582 12.2209 3.92499 12.1167 3.92499 12C3.92499 11.8834 3.94582 11.7792 3.98749 11.6875C4.02915 11.5959 4.09999 11.5 4.19999 11.4L11.075 4.50002C11.2417 4.35002 11.4375 4.27502 11.6625 4.27502C11.8875 4.27502 12.0833 4.35836 12.25 4.52502C12.4333 4.70836 12.525 4.91252 12.525 5.13752C12.525 5.36252 12.4333 5.55836 12.25 5.72502L6.84999 11.15H18.875C19.125 11.15 19.3292 11.2292 19.4875 11.3875C19.6458 11.5459 19.725 11.75 19.725 12C19.725 12.25 19.6458 12.4542 19.4875 12.6125C19.3292 12.7709 19.125 12.85 18.875 12.85H6.84999L12.275 18.3C12.4417 18.45 12.525 18.6375 12.525 18.8625C12.525 19.0875 12.4333 19.2917 12.25 19.475C12.0833 19.6417 11.8875 19.725 11.6625 19.725C11.4375 19.725 11.2333 19.6417 11.05 19.475Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrowBack.ab6164d3.svg";
export { ForwardRef as ReactComponent };